//import {version} from "Utils/config"

import { getGit, getVersion } from 'Utils/gitVersion.js';
//import { serverId } from 'Utils/settings';

let Sentry



class SentryHelper{

	constructor(){

	}

	//hub

	serverId = "devdemo"
	createSentryHub(){

		let sentryDns
		if (process.env.NODE_ENV === "production"){
			sentryDns = process.env.SENTRY_DSN
		}else if(process.env.NODE_ENV === "development"){
			sentryDns = process.env.DEV_SENTRY_DSN
		}

		this.serverId = "none"
		if (window.__OPTIONS__.server_id) {
			this.serverId = window.__OPTIONS__.server_id
		}
		


		if (!sentryDns) return
		
		let client = new Sentry.BrowserClient({
			dsn: sentryDns,
			environment: process.env.NODE_ENV,
			release: `${getVersion()}`,
			transport: Sentry.makeFetchTransport,
			stackParser: Sentry.defaultStackParser,
			integrations: Sentry.defaultIntegrations,
			attachStacktrace:true,
		});

		this.hub = new Sentry.Hub(client);

		
		this.hub.configureScope( (scope)=> {
			scope.setTag("serverId", this.serverId);
			scope.setTag("gitCommit", getGit());
		  });

		 //this.hub.captureMessage("create from hub test msg 7");


		 
	}


	// Sentry.addBreadcrumb({
	// 	category: "auth",
	// 	message: "Authenticated user " + user.email,
	// 	level: "info",
	//   });

	addBreadcrumb(category = "general", data){

	Sentry.addBreadcrumb({
		category: category,
		message: "breadcrumb",
		level: "info",
		data:data
	  });
	}

	captureMessage(msg){
		if (!this.hub)return
		this.hub.captureMessage(msg)
	}

	captureException(err){
		if (!this.hub)return

		this.hub.captureException(err)
	}



}

const sentryHelper = new SentryHelper()

function checkSentry(){	
	if (window.Sentry) {
		Sentry = window.Sentry;
		sentryHelper.createSentryHub()
	} else {
		setTimeout(() => checkSentry(), 300)
	};
};

// checkSentry();


export const sentryHub = sentryHelper;


export const SentryErrorType = {
    UNHANDLED_ERROR: "UNHANDLED ERROR",
	UI_ERROR: "UI Error",
    OPTIONS_UNDEFINED: "OPTIONS NOT EXIST",
    OPTIONS_ERROR: "OPTIONS ERROR",
	LOAD_RESOURCE_ERROR:"LOAD RESOURCE ERROR",
    LS_SERVER_SOCKTED_DISCONNECTED: "LS_SERVER_SOCKTED_DISCONNECTED",
    LS_SERVER_ERROR: "LS SERVER ERROR",
	LS_SERVER_DATA_UNDEFINED: "LS SERVER DATA NOT EXIST",
	LS_SERVER_DATA_ERROR: "LS_SERVER_DATA_ERROR",
	LOBBY_OPEN_ERROR:"LOBBY_OPEN_ERROR"
	};

  



// const client = new BrowserClient({
// 	dsn: process.env.SENTRY_DSN,
// 	environment: process.env.SENTRY_ENV,
// 	release: process.env.SENTRY_RELEASE,
// 	transport: makeFetchTransport,
// 	stackParser: defaultStackParser,
// 	integrations: defaultIntegrations,
//   });
  
//   const hub = new Hub(client);
  
  //export const sentry = hub;



// if(isSentryAvailable) {
// 	Sentry.init({
// 		environment: process.env.SENTRY_ENV,
// 		dsn: process.env.SENTRY_DSN,
// 		release: process.env.SENTRY_RELEASE,
// 		integrations: [new Sentry.BrowserTracing()],
// 		tracesSampleRate: 1.0,

// 	});
// 	if (window.user_id) {
// 		Sentry.setUser({id: window.user_id});
// 	}
	
// }
		//		window.__OPTIONS__.environment,
		// ignoreErrors: [
		// 	'WakeLock',
		// 	'fullscreen error',
		// 	'Copy command failed',
		// 	'Non-Error promise rejection captured',
		// 	'play()',
		// 	'not allowed'
		// ],
        // initialScope: {
        //     tags: { "my-tag": "init" },
        //     user: { id: 42, email: "alexandr.gakhov@bgaming.com" },
        //   },
		// beforeBreadcrumb(breadcrumb) {
		// 	return breadcrumb.category === "ui.click" ? null : breadcrumb;
		// },